import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
} from "@chakra-ui/react";



const CustomModal = (props:any) => {
   const {body, isOpen, onClose} = props

   return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select a token</ModalHeader>
        <ModalCloseButton />
        {body}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
